import {RouletteTypeVo} from '../../common/shared/api/nicolas/vo/enums/RouletteTypeVo.enum';
import {RouletteType} from '../generated/types';

export function createRouletteType(type: RouletteTypeVo) {
  return ROULETTE_TYPE_MAP[type];
}

const ROULETTE_TYPE_MAP = {
  [RouletteTypeVo.Standalone]: RouletteType.Standalone,
  [RouletteTypeVo.CashSponsor]: RouletteType.CashSponsor,
};
